import {
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
} from "@angular/core";
import { FormGroup, FormControl, Validators } from "@angular/forms";
import { FileInput } from "src/app/models/support";

@Component({
    selector: "residential-change-ticket",
    templateUrl: "./residential-change-ticket.component.html",
    styleUrls: ["./residential-change-ticket.component.scss"],
    standalone: false
})
export class ResidentialChangeTicketComponent implements OnInit, OnChanges {
  @Input() category: string;
  @Input() form: FormGroup;
  @Input() isVisible: boolean = false;

  constructor() {}

  ngOnInit(): void {}

  onFileSelect(file: FileInput) {
    this.form.get("proofOfAddressDocument").setValue({
      name: file.file.name,
      content: file.base64,
    });
  }

  onFileRemove() {
    this.form.get("proofOfAddressDocument").reset();
  }
  ngOnChanges(changes: SimpleChanges) {
    if (changes.category) {
      if (this.isVisible) this.initiateForm();
    }
  }
  markAsTouched(name: string) {
    this.form.get(name).markAsTouched();
  }
  initiateForm() {
    this.form.addControl(
      "proofOfAddressDocument",
      new FormControl("", [Validators.required])
    );
    this.form.addControl("street", new FormControl("", [Validators.required]));
    this.form.addControl("city", new FormControl("", [Validators.required]));
    this.form.addControl("country", new FormControl("", [Validators.required]));
    this.form.addControl("area", new FormControl("", []));
    this.form.addControl("postalCode", new FormControl("", []));

    this.form.addControl("message", new FormControl("", []));
  }
  get message() {
    return this.form.get("message");
  }
  get proofOfAddressDocument() {
    return this.form.get("proofOfAddressDocument");
  }

  get street() {
    return this.form.get("street");
  }
  get city() {
    return this.form.get("city");
  }
  get country() {
    return this.form.get("country");
  }

}
